// 按钮防抖 第一次触发，隔800ms 后再触发
export function debounce(func, wait) {
  let timer = null
  let lastInvokeTime = 0

  return function(...args) {
    const context = this
    const now = Date.now()

    // 清除之前的定时器
    if (timer) {
      clearTimeout(timer)
      timer = null
    }

    // 如果是第一次调用或者距离上次调用超过wait时间，立即执行
    if (lastInvokeTime === 0 || now - lastInvokeTime >= wait) {
      lastInvokeTime = now
      func.apply(context, args)
    } else {
      timer = setTimeout(() => {
        lastInvokeTime = Date.now()
        func.apply(context, args)
        timer = null
      }, wait - (now - lastInvokeTime))
    }
  }
}
// px 转化rem
export const pxToRem = (px) => {
    const docEl = document.documentElement
    const scale = docEl.clientWidth / 1920;
    let rootValue = 16
    rootValue = rootValue * scale
  return typeof px === 'number' ? (px / rootValue) * scale + 'rem' : px
}
// 屏幕分辨率放大字体 px => px
export const toPx = (px) => {
  const docEl = document.documentElement
  const scale = docEl.clientWidth / 1920;
  let rootValue = 16
  if (docEl.clientWidth > 2200) {
    rootValue =  px * scale
  } else if (docEl.clientWidth > 1900 && docEl.clientWidth < 2200) {
    rootValue = px * scale
  } else if (docEl.clientWidth < 1900) {
    rootValue = px * scale
  }
  return rootValue
}
export const msToMinutesAndSeconds = function (ms) {
    const minutes = Math.floor(ms / 60000);
    const seconds = ((ms % 60000) / 1000).toFixed(0);
    return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
}
// 音频处理
export const playFeedBackAudio = (audioUrl) => {
  if (!audioUrl) return;
  const audio = new Audio(audioUrl);
  audio.play();
  audio.onended = () => {
    audio.remove();
  };
};